import React, { createContext, useContext, useState } from "react"

/* ═══════════════════════════════════════════════════════════
   TRANSLATIONS
═══════════════════════════════════════════════════════════ */
export const translations = {
    en: {
        /* ── top bar ── */
        brandName:      "Royal Kavery",
        memberPortal:   "Member Portal",
        navProfile:     "My Profile",
        navMatches:     "My Matches",
        navChat:        "Chat",
        logout:         "Logout",

        /* ── member portal page ── */
        myAccount:          "My Account",
        myProfilePage:      "My Profile",
        myProfileDesc:      "View and update your profile, photo, and account settings.",
        changePassword:     "Change Password",
        editProfile:        "Edit Profile",
        save:               "Save",
        saving:             "Saving…",
        cancel:             "Cancel",
        profilePhotoTip:    "Change profile photo",
        photos:             "Photos",
        photosDesc:         "Up to 5 photos. First photo is your profile picture.",
        addPhoto:           "Add photo",
        removePhoto:        "Remove photo",
        primaryPhoto:       "Primary",
        photoLimitReached:  "Maximum 5 photos reached. Remove one to add another.",
        photoTooLarge:      "Image is too large. Please use a smaller photo (under ~2 MB).",
        photoUploading:     "Uploading…",

        /* progress bar */
        profileCompleteness:  "Profile completeness",
        fieldsFilled:         "fields filled",
        fieldsRemaining:      "remaining",
        profileComplete:      "Your profile is complete!",
        greatJob:             "Great job! Your profile is 100% complete.",
        fillIn:               "Fill in:",
        missing:              "Missing",

        /* profile field labels & tips */
        firstName:            "First Name",
        firstNameTip:         "Your given name",
        lastName:             "Last Name",
        lastNameTip:          "Your family name",
        dateOfBirth:          "Date of Birth",
        dateOfBirthTip:       "Used to calculate age on your profile",
        starNakshatra:        "Star (Nakshatra)",
        starTip:              "Essential for Jathaga Porutham matching",
        religion:             "Religion",
        caste:                "Caste",
        maritalStatus:        "Marital Status",
        height:               "Height",
        education:            "Education",
        occupation:           "Occupation",
        salary:               "Salary",
        nativePlace:          "Native Place",
        currentCity:          "Current City",
        expectations:         "Partner Expectations / About you",
        expectationsTip:      "This is the first thing matches read — make it personal",

        /* profile field placeholders */
        phStar:         "e.g. Rohini",
        phMarital:      "e.g. Never married",
        phHeight:       "e.g. 5.6 ft",
        phEducation:    "e.g. B.E. Computer Science",
        phOccupation:   "e.g. Software Engineer",
        phSalary:       "e.g. 50,000 / month",
        phNative:       "e.g. Trichy",
        phCity:         "e.g. Chennai",
        phExpectations: "Describe what you're looking for in a partner…",

        /* section headings */
        personalDetails:    "Personal details",
        educationCareer:    "Education & Career",
        aboutExpectations:  "About & Expectations",

        /* tabs */
        myProfileTab:   "My Profile",
        shortlistTab:   "Shortlist",
        chatTab:        "Chat",

        /* shortlist tab */
        loadingShortlist:   "Loading shortlisted profiles…",
        shortlistEmpty:     "Your shortlist is empty",
        shortlistEmptyDesc: "Go to My Matches and tap the heart on a profile to shortlist them.",

        /* password modal */
        security:           "Security",
        changePasswordTitle:"Change Password",
        currentPassword:    "Current password",
        newPassword:        "New password",
        confirmNewPassword: "Confirm new password",
        passwordHint:       "Password must be at least 8 characters and not too common.",
        changing:           "Changing…",
        passwordOk:         "Password changed successfully.",

        /* ── matches page ── */
        findYourMatch:      "Find Your Match",
        suggestedMatches:   "Suggested matches with jathaga porutham",
        matchesSubtitle:    "Heart to shortlist · \"Not interested\" hides a profile · Chat to connect without sharing your number.",
        suggestions:        "Suggestions",
        shortlist:          "Shortlist",
        blocked:            "Blocked",
        searchPlaceholder:  "Search name, mobile, ref id, star...",
        loadingMatches:     "Loading…",
        noSuggestions:      "No matching profiles. Make sure your gender and star are filled in your profile.",
        noShortlist:        "Your shortlist is empty. Tap the heart on a suggested profile to add it here.",
        noBlocked:          "You haven't blocked anyone yet.",
        viewProfile:        "View Profile",
        detailedPorutham:   "Detailed Porutham",
        chatBtn:            "Chat",
        report:             "Report",
        reportTip:          "Report this profile to the admin team",
        notInterested:      "Not interested",
        notInterestedTip:   "Mark not interested — hides this profile from your suggestions",
        unblock:            "Unblock",
        addShortlist:       "Add to shortlist",
        removeShortlist:    "Remove from shortlist",
        poruthamDetail:     "Porutham Detail",
        starNotSet:         "Star not set",

        /* slide-over tabs */
        profileTab:     "Profile",
        poruthamTab:    "Porutham",
        chatTab:        "Chat",
        profileTabTip:  "View profile details",
        poruthamTabTip: "View Jathaga Porutham compatibility",
        chatTabTip:     "Open private chat",

        /* slide-over profile sections */
        basicInfo:              "Basic Info",
        educationCareerSection: "Education & Career",
        aboutSection:           "About / Expectations",
        jathagaPorutham:        "Jathaga Porutham",

        /* slide-over field labels */
        gender:             "Gender",
        religionCaste:      "Religion/Caste",
        maritalStatusLabel: "Marital Status",
        heightLabel:        "Height",
        educationLabel:     "Education",
        occupationLabel:    "Occupation",
        salaryLabel:        "Salary",
        native:             "Native",
        currentCityLabel:   "Current City",

        /* porutham tab */
        computingPorutham:  "Computing Jathaga Porutham…",
        bride:              "Bride",
        groom:              "Groom",
        starMissingError:   "Make sure both profiles have their star (nakshatra) filled in.",

        /* print */
        printTip:           "Print this profile",
        closeTip:           "Close",
        printedFrom:        "Printed from Royal Kavery Matrimony Member Portal",

        /* chat page */
        privateChat:            "Private Chat",
        conversations:          "Conversations",
        phoneHidden:            "Phone numbers are automatically hidden in messages for safety.",
        enableNotifications:    "Enable desktop notifications",
        notificationsEnabled:   "Notifications enabled",
        notificationsBlocked:   "Notifications blocked",
        searchConversations:    "Search conversations",
        noConversations:        "No conversations yet. Open a profile from Matches and tap \"Chat\".",
        sayHello:               "Say hello — your message starts the conversation. Phone numbers are hidden automatically.",
        typingPlaceholder:      "Type a message…",
        online:                 "Online now",
        offline:                "Offline",
        lastSeen:               "Last seen",
        pickConversation:       "Pick a conversation on the left, or open a profile and tap \"Chat\".",
        sendMessage:            "Send",
        readReceipt:            "Read",
        ref:                    "Ref",
        yrs:                    "yrs",

        /* ── plan / membership tier ── */
        freePlan:               "Free Plan",
        paidMember:             "Premium Member",
        planExpiry:             "Valid until",
        planExpired:            "Plan expired — contact admin to renew",
        upgradeNow:             "Upgrade to Premium",
        upgradeTitle:           "Premium Feature",
        upgradeDescContact:     "Upgrade your plan to view phone number and email address.",
        upgradeDescJathagam:    "Upgrade your plan to view full jathagam, rasi, and horoscope details.",
        upgradeDescPorutham:    "Upgrade your plan to view the detailed porutham breakdown.",
        contactSection:         "Contact Information",
        jathagamSection:        "Jathagam / Horoscope",
        familySection:          "Family Details",

        /* plan card */
        membershipPlan:         "Membership Plan",
        activePlan:             "Active Plan",
        expiresOn:              "Expires on",
        expiredOn:              "Expired on",
        daysLeft:               "days left",
        daysOf:                 "of",
        renewPlan:              "Renew Plan",
        upgradePlan:            "Upgrade Plan",
        contactAdmin:           "Contact admin to upgrade",
        freePlanDesc:           "You are on the Free Plan. Upgrade to unlock contact details, jathagam, and full porutham.",
        freeFeature1:           "View suggested matches",
        freeFeature2:           "Basic profile details",
        freeFeature3:           "Chat with matches",
        premiumFeature1:        "Phone & email contact details",
        premiumFeature2:        "Full jathagam & rasi details",
        premiumFeature3:        "Detailed porutham breakdown",
        premiumFeature4:        "Priority listing",
        choosePlan:             "Choose a plan below and contact admin to activate:",
        planValid:              "validity",
        days:                   "days",
        plansTab:               "Plans",

        /* new slide-over field labels */
        phone:              "Phone",
        emailLabel:         "Email",
        birthTime:          "Birth Time",
        birthPlace:         "Birth Place",
        rasiLabel:          "Rasi (Zodiac)",
        dhisaiLabel:        "Dhisai (Dasha)",
        aboutMeLabel:       "About",
        weightLabel:        "Weight",
        complexionLabel:    "Complexion",
        motherTongueLabel:  "Mother Tongue",
        subCasteLabel:      "Sub Caste",
        fatherNameLabel:    "Father's Name",
        motherNameLabel:    "Mother's Name",
        siblingsLabel:      "Siblings",
        familyTypeLabel:    "Family Type",
        familyStatusLabel:  "Family Status",
        familyValuesLabel:  "Family Values",
    },

    ta: {
        /* ── top bar ── */
        brandName:      "ராயல் காவேரி",
        memberPortal:   "உறுப்பினர் போர்டல்",
        navProfile:     "என் சுயவிவரம்",
        navMatches:     "என் பொருத்தங்கள்",
        navChat:        "அரட்டை",
        logout:         "வெளியேறு",

        /* ── member portal page ── */
        myAccount:          "என் கணக்கு",
        myProfilePage:      "என் சுயவிவரம்",
        myProfileDesc:      "உங்கள் சுயவிவரம், புகைப்படம் மற்றும் கணக்கு அமைப்புகளை பார்க்கவும் புதுப்பிக்கவும்.",
        changePassword:     "கடவுச்சொல் மாற்று",
        editProfile:        "சுயவிவரம் திருத்து",
        save:               "சேமி",
        saving:             "சேமிக்கிறது…",
        cancel:             "ரத்து",
        profilePhotoTip:    "சுயவிவர புகைப்படம் மாற்று",
        photos:             "புகைப்படங்கள்",
        photosDesc:         "அதிகபட்சம் 5 புகைப்படங்கள். முதல் புகைப்படம் சுயவிவர படமாகும்.",
        addPhoto:           "புகைப்படம் சேர்",
        removePhoto:        "புகைப்படம் நீக்கு",
        primaryPhoto:       "முதன்மை",
        photoLimitReached:  "அதிகபட்சம் 5 புகைப்படங்கள் சேர்க்கப்பட்டன. புதியதை சேர்க்க ஒன்றை நீக்கவும்.",
        photoTooLarge:      "படம் மிகவும் பெரியது. சிறிய படத்தை பயன்படுத்தவும்.",
        photoUploading:     "பதிவேற்றுகிறது…",

        /* progress bar */
        profileCompleteness:  "சுயவிவர முழுமை",
        fieldsFilled:         "தகவல்கள் நிரப்பப்பட்டன",
        fieldsRemaining:      "மீதமுள்ளன",
        profileComplete:      "உங்கள் சுயவிவரம் முழுமையானது!",
        greatJob:             "சாபாஷ்! உங்கள் சுயவிவரம் 100% முழுமையானது.",
        fillIn:               "நிரப்புக:",
        missing:              "நிரப்பவில்லை",

        /* profile field labels & tips */
        firstName:            "முதல் பெயர்",
        firstNameTip:         "உங்கள் பெயர்",
        lastName:             "கடைசி பெயர்",
        lastNameTip:          "உங்கள் குடும்பப் பெயர்",
        dateOfBirth:          "பிறந்த தேதி",
        dateOfBirthTip:       "வயதை காட்ட பயன்படுகிறது",
        starNakshatra:        "நட்சத்திரம்",
        starTip:              "ஜாதக பொருத்தத்திற்கு அவசியம்",
        religion:             "மதம்",
        caste:                "ஜாதி",
        maritalStatus:        "திருமண நிலை",
        height:               "உயரம்",
        education:            "கல்வி",
        occupation:           "தொழில்",
        salary:               "சம்பளம்",
        nativePlace:          "சொந்த ஊர்",
        currentCity:          "தற்போதைய நகரம்",
        expectations:         "துணை எதிர்பார்ப்புகள்",
        expectationsTip:      "பொருத்தங்கள் முதலில் படிப்பது இதை தான் — தனிப்பட்டதாக எழுதுங்கள்",

        /* profile field placeholders */
        phStar:         "எ.கா. ரோகிணி",
        phMarital:      "எ.கா. திருமணம் ஆகாதவர்",
        phHeight:       "எ.கா. 5.6 அடி",
        phEducation:    "எ.கா. கணினி பொறியியல்",
        phOccupation:   "எ.கா. மென்பொருள் பொறியாளர்",
        phSalary:       "எ.கா. 50,000 / மாதம்",
        phNative:       "எ.கா. திருச்சி",
        phCity:         "எ.கா. சென்னை",
        phExpectations: "நீங்கள் எதை எதிர்பார்க்கிறீர்கள் என்று விவரிக்கவும்…",

        /* section headings */
        personalDetails:    "தனிப்பட்ட விவரங்கள்",
        educationCareer:    "கல்வி & தொழில்",
        aboutExpectations:  "பற்றி & எதிர்பார்ப்புகள்",

        /* tabs */
        myProfileTab:   "என் சுயவிவரம்",
        shortlistTab:   "குறுகிய பட்டியல்",
        chatTab:        "அரட்டை",

        /* shortlist tab */
        loadingShortlist:   "குறுகிய பட்டியல் சுயவிவரங்கள் ஏற்றுகிறது…",
        shortlistEmpty:     "உங்கள் குறுகிய பட்டியல் காலியாக உள்ளது",
        shortlistEmptyDesc: "என் பொருத்தங்களுக்கு சென்று ஒரு சுயவிவரத்தில் இதயத்தை தட்டவும்.",

        /* password modal */
        security:           "பாதுகாப்பு",
        changePasswordTitle:"கடவுச்சொல் மாற்று",
        currentPassword:    "தற்போதைய கடவுச்சொல்",
        newPassword:        "புதிய கடவுச்சொல்",
        confirmNewPassword: "புதிய கடவுச்சொல்லை உறுதிப்படுத்துக",
        passwordHint:       "கடவுச்சொல் குறைந்தது 8 எழுத்துக்கள் இருக்க வேண்டும்.",
        changing:           "மாற்றுகிறது…",
        passwordOk:         "கடவுச்சொல் வெற்றிகரமாக மாற்றப்பட்டது.",

        /* ── matches page ── */
        findYourMatch:      "உங்கள் பொருத்தத்தை கண்டுபிடியுங்கள்",
        suggestedMatches:   "ஜாதக பொருத்தத்துடன் பரிந்துரைக்கப்பட்ட பொருத்தங்கள்",
        matchesSubtitle:    "இதயம் → குறுகிய பட்டியல் · \"ஆர்வமில்லை\" → மறைக்கும் · அரட்டை → தொடர்பு கொள்ளுங்கள்.",
        suggestions:        "பரிந்துரைகள்",
        shortlist:          "குறுகிய பட்டியல்",
        blocked:            "தடுக்கப்பட்டவர்கள்",
        searchPlaceholder:  "பெயர், மொபைல், ரெஃப் ஐடி, நட்சத்திரம்...",
        loadingMatches:     "ஏற்றுகிறது…",
        noSuggestions:      "பொருத்தும் சுயவிவரங்கள் இல்லை. உங்கள் பாலினம் மற்றும் நட்சத்திரம் நிரப்பப்பட்டுள்ளதா என்று சரிபாருங்கள்.",
        noShortlist:        "உங்கள் குறுகிய பட்டியல் காலியாக உள்ளது. ஒரு பரிந்துரைக்கப்பட்ட சுயவிவரத்தில் இதயத்தை தட்டி சேர்க்கவும்.",
        noBlocked:          "நீங்கள் இன்னும் யாரையும் தடுக்கவில்லை.",
        viewProfile:        "சுயவிவரம் பார்",
        detailedPorutham:   "விரிவான பொருத்தம்",
        chatBtn:            "அரட்டை",
        report:             "புகார் செய்",
        reportTip:          "நிர்வாக குழுவிடம் புகார் செய்க",
        notInterested:      "ஆர்வமில்லை",
        notInterestedTip:   "ஆர்வமில்லை — இந்த சுயவிவரத்தை மறைக்கும்",
        unblock:            "தடுப்பை நீக்கு",
        addShortlist:       "குறுகிய பட்டியலில் சேர்",
        removeShortlist:    "குறுகிய பட்டியலில் இருந்து நீக்கு",
        poruthamDetail:     "பொருத்த விவரம்",
        starNotSet:         "நட்சத்திரம் அமைக்கப்படவில்லை",

        /* slide-over tabs */
        profileTab:     "சுயவிவரம்",
        poruthamTab:    "பொருத்தம்",
        chatTab:        "அரட்டை",
        profileTabTip:  "சுயவிவர விவரங்கள் பார்க்க",
        poruthamTabTip: "ஜாதக பொருத்தம் பார்க்க",
        chatTabTip:     "தனியார் அரட்டை திறக்க",

        /* slide-over profile sections */
        basicInfo:              "அடிப்படை தகவல்",
        educationCareerSection: "கல்வி & தொழில்",
        aboutSection:           "பற்றி / எதிர்பார்ப்புகள்",
        jathagaPorutham:        "ஜாதக பொருத்தம்",

        /* slide-over field labels */
        gender:             "பாலினம்",
        religionCaste:      "மதம்/ஜாதி",
        maritalStatusLabel: "திருமண நிலை",
        heightLabel:        "உயரம்",
        educationLabel:     "கல்வி",
        occupationLabel:    "தொழில்",
        salaryLabel:        "சம்பளம்",
        native:             "சொந்த ஊர்",
        currentCityLabel:   "தற்போதைய நகரம்",

        /* porutham tab */
        computingPorutham:  "ஜாதக பொருத்தம் கணக்கிடுகிறது…",
        bride:              "மணமகள்",
        groom:              "மணமகன்",
        starMissingError:   "இரு சுயவிவரங்களிலும் நட்சத்திரம் நிரப்பப்பட்டுள்ளதா என்று சரிபாருங்கள்.",

        /* print */
        printTip:           "இந்த சுயவிவரத்தை அச்சிடு",
        closeTip:           "மூடு",
        printedFrom:        "ராயல் காவேரி மேட்ரிமோனி உறுப்பினர் போர்டலில் இருந்து அச்சிடப்பட்டது",

        /* chat page */
        privateChat:            "தனியார் அரட்டை",
        conversations:          "உரையாடல்கள்",
        phoneHidden:            "தொலைபேசி எண்கள் செய்திகளில் தானாக மறைக்கப்படுகின்றன.",
        enableNotifications:    "டெஸ்க்டாப் அறிவிப்புகளை இயக்கு",
        notificationsEnabled:   "அறிவிப்புகள் இயக்கப்பட்டன",
        notificationsBlocked:   "அறிவிப்புகள் தடுக்கப்பட்டன",
        searchConversations:    "உரையாடல்களை தேடு",
        noConversations:        "இன்னும் உரையாடல்கள் இல்லை. பொருத்தங்களில் சுயவிவரம் திறந்து \"அரட்டை\" என்பதை தட்டவும்.",
        sayHello:               "வணக்கம் சொல்லுங்கள் — உங்கள் செய்தி உரையாடலை தொடங்கும். தொலைபேசி எண்கள் தானாக மறைக்கப்படும்.",
        typingPlaceholder:      "ஒரு செய்தி தட்டச்சு செய்யவும்…",
        online:                 "இப்போது ஆன்லைனில்",
        offline:                "ஆஃப்லைன்",
        lastSeen:               "கடைசியாக பார்த்தது",
        pickConversation:       "இடதுபுறத்தில் ஒரு உரையாடலை தேர்ந்தெடுக்கவும், அல்லது ஒரு சுயவிவரத்தை திறந்து \"அரட்டை\" என்பதை தட்டவும்.",
        sendMessage:            "அனுப்பு",
        readReceipt:            "படிக்கப்பட்டது",
        ref:                    "ரெஃப்",
        yrs:                    "வயது",

        /* ── plan / membership tier ── */
        freePlan:               "இலவச திட்டம்",
        paidMember:             "பிரீமியம் உறுப்பினர்",
        planExpiry:             "செல்லுபடியாகும் வரை",
        planExpired:            "திட்டம் காலாவதியானது — புதுப்பிக்க நிர்வாகியை தொடர்பு கொள்ளவும்",
        upgradeNow:             "பிரீமியமாக மேம்படுத்து",
        upgradeTitle:           "பிரீமியம் அம்சம்",
        upgradeDescContact:     "தொலைபேசி எண் மற்றும் மின்னஞ்சல் பார்க்க திட்டத்தை மேம்படுத்தவும்.",
        upgradeDescJathagam:    "முழு ஜாதகம், ராசி மற்றும் ஜோதிட விவரங்களைப் பார்க்க திட்டத்தை மேம்படுத்தவும்.",
        upgradeDescPorutham:    "விரிவான பொருத்த விவரங்களைப் பார்க்க திட்டத்தை மேம்படுத்தவும்.",
        contactSection:         "தொடர்பு தகவல்",
        jathagamSection:        "ஜாதகம் / ஜோதிடம்",
        familySection:          "குடும்ப விவரங்கள்",

        /* plan card */
        membershipPlan:         "உறுப்பினர் திட்டம்",
        activePlan:             "செயலில் உள்ள திட்டம்",
        expiresOn:              "காலாவதி தேதி",
        expiredOn:              "காலாவதியானது",
        daysLeft:               "நாட்கள் மீதமுள்ளன",
        daysOf:                 "இல்",
        renewPlan:              "திட்டம் புதுப்பி",
        upgradePlan:            "திட்டம் மேம்படுத்து",
        contactAdmin:           "மேம்படுத்த நிர்வாகியை தொடர்பு கொள்ளவும்",
        freePlanDesc:           "நீங்கள் இலவச திட்டத்தில் உள்ளீர்கள். தொடர்பு விவரங்கள், ஜாதகம் மற்றும் பொருத்தம் காண மேம்படுத்தவும்.",
        freeFeature1:           "பரிந்துரைக்கப்பட்ட பொருத்தங்கள் பார்க்க",
        freeFeature2:           "அடிப்படை சுயவிவர விவரங்கள்",
        freeFeature3:           "பொருத்தங்களுடன் அரட்டை",
        premiumFeature1:        "தொலைபேசி & மின்னஞ்சல் தொடர்பு விவரங்கள்",
        premiumFeature2:        "முழு ஜாதகம் & ராசி விவரங்கள்",
        premiumFeature3:        "விரிவான பொருத்த விவரங்கள்",
        premiumFeature4:        "முன்னுரிமை பட்டியல்",
        choosePlan:             "கீழே ஒரு திட்டத்தை தேர்வு செய்து நிர்வாகியை தொடர்பு கொள்ளவும்:",
        planValid:              "செல்லுபடி",
        days:                   "நாட்கள்",
        plansTab:               "திட்டங்கள்",

        /* new slide-over field labels */
        phone:              "தொலைபேசி",
        emailLabel:         "மின்னஞ்சல்",
        birthTime:          "பிறந்த நேரம்",
        birthPlace:         "பிறந்த இடம்",
        rasiLabel:          "ராசி",
        dhisaiLabel:        "திசை",
        aboutMeLabel:       "பற்றி",
        weightLabel:        "எடை",
        complexionLabel:    "நிறம்",
        motherTongueLabel:  "தாய்மொழி",
        subCasteLabel:      "உட்பிரிவு ஜாதி",
        fatherNameLabel:    "தந்தையின் பெயர்",
        motherNameLabel:    "தாயின் பெயர்",
        siblingsLabel:      "உடன்பிறந்தவர்கள்",
        familyTypeLabel:    "குடும்ப வகை",
        familyStatusLabel:  "குடும்ப நிலை",
        familyValuesLabel:  "குடும்ப மதிப்புகள்",
    },
}

/* ═══════════════════════════════════════════════════════════
   CONTEXT
═══════════════════════════════════════════════════════════ */
const LanguageContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k })

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(() => {
        try {
            return localStorage.getItem("memberLang") || "en"
        } catch { return "en" }
    })

    const setLang = (l) => {
        setLangState(l)
        try { localStorage.setItem("memberLang", l) } catch {}
    }

    const t = (key) => translations[lang]?.[key] ?? translations.en[key] ?? key

    return (
        <LanguageContext.Provider value={{ lang, setLang, t }}>
            {children}
        </LanguageContext.Provider>
    )
}

export const useLanguage = () => useContext(LanguageContext)
